import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEventsSchemas } from 'shared/db/validation/schema/events';
import { Validator } from 'shared/db/validation/validator';
import { EventRawRecord, EventUpdateRawRecord } from 'shared/types/Events';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EventsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEventsSchemas();

const addValidator = createDBEntityValidator<EventRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<EventUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-events'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEventsInputValidation = <T extends Record<string, unknown>>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const eventsInputValidation: EventsDBValidation = {
    add: createEventsInputValidation(addValidator, validationStrategy),
    update: createEventsInputValidation(updateValidator, validationStrategy),
    delete: createEventsInputValidation(deleteValidator, validationStrategy),
};
